import styles from './profile_image.module.scss';
import avatarStyles from './../../../components/avatar/avatar.module.scss';
import {Form} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../../store/store.ts';
import {sendProfilePicture} from '../../../store/slices/me_slice.ts';

interface OwnProps {
    profilePictureUrl: string | null;
    name: string;
}

export function EditableProfileImage({profilePictureUrl, name}: OwnProps) {
    const token = useAppSelector((state) => state.exchangeToken.token);
    const dispatch = useAppDispatch();
    const handleChange = async (file: File) => {
        if (token) {
            dispatch(sendProfilePicture({token: token, file: file}));
        }
    };

    return (
        <div className={styles.profile_image_container}>
            <Form method="post">
                <input
                    id="profile-picture-upload"
                    type="file"
                    name="profile-picture-upload"
                    className={styles.file_input}
                    onChange={(e) => e.target.files && handleChange(e.target.files[0])}
                    accept="image/*"
                />
                <div className={styles.upload_button}>
                    <label htmlFor="profile-picture-upload">
                        <i className="fa-light fa-pen"></i>
                    </label>
                </div>
                {profilePictureUrl != null ? (
                    <img
                        src={profilePictureUrl}
                        alt="Avatar image"
                        onError={(e) => (e.currentTarget.style.display = 'none')}
                    />
                ) : (
                    // Borrow the avatar initials here
                    <div className={avatarStyles.avatar__initials}>
                        <span>{name.substring(0, 1)}</span>
                    </div>
                )}
            </Form>
        </div>
    );
}
